import { ScheduleType } from '@core/api';
import { z } from '@core/validator';
import { Locales } from '../../strings/Locales.js';
var HourMinuteSchema = z.object({
    hour: z.number().min(0).max(23),
    minute: z.number().min(0).max(59)
});
var DailyFrequency = z.object({
    type: z.literal(ScheduleType.Daily),
    hourMinute: HourMinuteSchema
});
var HourlyFrequency = z.object({
    type: z.literal(ScheduleType.Hourly),
    value: z.number().min(1).max(12)
});
var MinutelyFrequency = z.object({
    type: z.literal(ScheduleType.Minutely),
    value: z.number().min(5).max(30)
});
var MonthlyFrequency = z.object({
    type: z.literal(ScheduleType.Monthly),
    hourMinute: HourMinuteSchema,
    value: z.number().min(1).max(6),
    monthDay: z.number().min(1).max(28)
});
var WeeklyFrequency = z.object({
    type: z.literal(ScheduleType.Weekly),
    hourMinute: HourMinuteSchema,
    weekDays: z.array(z.string()).min(1, {
        message: Locales.format('FrequencySelector.WEEKLY.daysWeek.error.min')
    }).max(6, {
        message: Locales.format('FrequencySelector.WEEKLY.daysWeek.error.max')
    })
});
export var FrequencySchema = z.object({
    frequency: z.discriminatedUnion('type', [
        DailyFrequency,
        HourlyFrequency,
        MinutelyFrequency,
        MonthlyFrequency,
        WeeklyFrequency
    ])
});

//# sourceMappingURL=FrequencySchema.js.map